import { CrmJobDTO } from '../..';
import axios from '../../../axios';
import { CrmJobFilterDTO } from '../types/CrmJobFilterDTO';

const url = '/invoicingservice/api/crm/jobs';

export const getCrmJobById = (id: string) => axios.get(`${url}/${id}`);

export const createCrmJob = (crmJob: CrmJobDTO) => axios.post(`${url}/add`, crmJob);

export const updateCrmJob = (crmJob: CrmJobDTO) => axios.put(`${url}/update`, crmJob);

export const getAllCrmJobs = (crmJobFilterDTO: CrmJobFilterDTO) =>
  axios.post(`${url}/list`, crmJobFilterDTO);

export const downloadCrmJobs = (crmJobFilterDTO: CrmJobFilterDTO, type: string) =>
  axios.post(`${url}/download/${type}`, crmJobFilterDTO, {
    responseType: 'arraybuffer',
  });

export const getEligibleContacts = (jobId: string) =>
  axios.get(`${url}/${jobId}/eligible-contacts`);

export const getTaggedContacts = (jobId: string) => axios.get(`${url}/${jobId}/tagged-contacts`);

export const tagContact = (jobId: string, contactId: string) =>
  axios.post(`${url}/${jobId}/tag-contact`, contactId);

export const untagContact = (jobId: string, contactId: string) =>
  axios.delete(`${url}/${jobId}/tag-contact/${contactId}`);
